import DateRangeInput from './DateRangeInput';

export type { DateRangeInputProps } from './DateRangeInput';
export default DateRangeInput;
